import React from 'react';

const ListingFilters = ({
  destinations,
  travelTypes = [],
  setter,
  activeFilters: {
    destination: currentDestination,
    travelType: currentListingType,
  },
  holidaysListing = false,
}) => {
  if (holidaysListing) {
    return (
      <div className="c-order__type">
        {/* All and at least 2 other types */}
        {travelTypes.length > 2 && (
          <>
            <h3>Filter by</h3>

            <ul className="c-order__type__list">
              {travelTypes.map((type) => (
                <li
                  className={`c-order__type__list__item ${
                    type.slug === currentListingType.slug &&
                    (type.subtypeSlug === currentListingType.subtypeSlug ||
                      (!type.subtypeSlug && !currentListingType.subtypeSlug))
                      ? 'c-order__type__list__item--active'
                      : ''
                  }`}
                  key={`c-order__type__list__item--${type.slug}${
                    type.subtypeSlug ? `-${type.subtypeSlug}` : ''
                  }`}
                  onClick={() => setter(type)}
                >
                  <a
                    className="u-pointer"
                    dangerouslySetInnerHTML={{ __html: type.display }}
                  ></a>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    );
  } else {
    return (
      <div className="c-order__filter">
        <h3>Filter by</h3>

        <ul className="c-order__filter__list">
          {destinations.map((dest) => (
            <li
              className={`c-order__filter__list__item ${
                dest.id === currentDestination.id
                  ? 'c-order__filter__list__item--active'
                  : ''
              }`}
              key={`c-order__filter__list__item--${dest.id}`}
              onClick={() => setter(dest)}
            >
              <a
                className="u-pointer"
                dangerouslySetInnerHTML={{ __html: dest.display }}
              ></a>
            </li>
          ))}
        </ul>
      </div>
    );
  }
};

export default ListingFilters;
